<template>
	<div id="haoke1">
		<!-- 遮罩层 -->
		<header>
			<div class="title">
				<!-- <span class="hao">耗课列表</span> -->
			</div>
			<div class="countList">
				<ul>
					<li style="margin-right: 20px;">合计：<span class="money">{{ tableData.count}}</span>元</li>
					<li style="margin-right: 20px;">修正数量：<span class="person">{{ tableData.person}}</span>人</li>
				</ul>
				<el-button size="mini" class="btn" style="margin: 0" @click="jump('haoke1')" round>
					返回
				</el-button>
			</div>
		</header>
		<div class="tableheadBox">

			<div class="demo-input-suffix" style="margin: 0 10px;">
				日期：
				<el-date-picker size="mini" class="shangsj" v-model="value2" type="daterange" start-placeholder="开始日期"
				 end-placeholder="结束日期" value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
            类型:
			<el-select v-model="source" placeholder="请选择类型" size="mini" style="width: 130px;height: 30px;line-height: 30px;margin-left: 10px;vertical-align: middle">
				<el-option value="">请选择</el-option>
				<el-option v-for="(item,kk2) in options" :key="kk2"  :label="item.label" :value="item.value"></el-option>
			</el-select>
            <div class="demo-input-suffix" style="margin-left: 10px;">
                会员姓名：
                <el-input class="msg" size="mini" placeholder="" v-model="input2" @keyup.enter.native="searchk" clearable>
                </el-input>
            </div>
			<el-button v-on:click="searchk" size="mini" class="btns" icon="el-icon-search"></el-button>
		</div>


		<div style="padding: 0 0.2rem">
			<table class="table table-bordered">
				<thead>
					<tr>
						<th></th>
						<th>会员姓名</th>
						<th>合约类型</th>
						<th>修正类型</th>
						<th>操作人员</th>
						<th>金额合计</th>
						<th>日期</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(ta,index) in tableData.data" :key="index">
						<td>{{index+1}}</td>
						<td>{{ta.baobao_name}}</td>
						<td>{{ta.item_name}}</td>
						<td>{{ta.kc_name}}</td>
						<td>{{ta.username}}</td>
						<td>{{ta.k_h}}</td>
						<td>{{ta.create_time}}</td>
					</tr>
					<tr v-if="tableData.data==''">
						<td colspan="10" align="center">暂无数据</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="block_page">
			共有{{tableData.total}}条记录 当前{{tableData.page}}页/共{{tableData.totalpage}}页
		</div>
		<div class="table-bottom">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="tableData.page"
			 :page-size="pagesize" layout="prev, pager, next, jumper" :total='tableData.total'>
			</el-pagination>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				isactive: false,
				tableData: {
					data: [],
					total: 0,
					page: 1,
					count: '',
					part: '',
					person: '',
					totalpage: '',
				},
				pagesize: 20,
				teacher: [],
				token: "",
				options: [{
					value: '退费',
					label: '退费'
				}, {
					value: '结业',
					label: '结业'
				}],
				value1: '',
				value2: [],
				input1: '',
				input2: '',
				stime: '',
				etime: '',
				items:[],//项目
				source:'',
                centre_id:'',
			};
		},
		methods: {
			hkdata: function() {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
				let self = this;
				if (this.value2 != null) {
					self.stime = self.value2[0]
					self.etime = self.value2[1]
				} else {
					self.stime = ''
					self.etime = ''
				}

				$.ajax({
					url: process.env.apiUrl + "saas/biao/xzjl",
					type: "post",
					data: {
						token: self.token,
						time_s: self.stime,
						time_e: self.etime,
						name: self.input2,
						page: self.tableData.page,
						source: self.source
					},
					success: function(data) {
                        loading.close();
						if (data.status == 1) {
							self.tableData.data = data.data.data;
							self.tableData.total = data.data.count;
							self.tableData.person = data.data.count;
							self.tableData.count = data.data.he_money;
							self.tableData.part = data.data.hk_num;
							self.tableData.totalpage = data.data.total;
						} else if (data.status == 2) {
							self.tableData.data = ""
						}
					},
					error: function() {
                    	loading.close();
                	}
				})
			},
			changeActive() {
				this.isactive = !this.isactive;
				this.value1 = '',
				this.value2 = '',
				this.input1 = '',
				this.input2 = '',
				this.searchk();
			},
            jump: function(d) {
                this.$router.push(d)
            },
			// 搜索
			searchk() {
				this.tableData.page = 1;
                this.hkdata();
			},
			handleSizeChange(val) {
				this.pagesize = val;
			},
			handleCurrentChange(val) {
				this.tableData.page = val;
				// this.tableData.page += 2;
				if (this.isactive == false) {
					this.hkdata();
				} else {
					this.wjkdata();
				}
			},
			//选择项目
			get_item(){
				let self = this;
				$.ajax({
					type: 'POST',
					url: process.env.apiUrl + "saas/biao/item_type",
					data: {
						token: self.token,
					},
					success: function(res) {
						if (res.status == 1) {
                            self.centre = res.centre_id
						}
					},
					error: function(data) {
						self.$message.error(`请求失败`);
					}
				});
			},
		},
		mounted: function() {
			this.token = $.cookie('token')


            this.hkdata()
			this.get_item()
		}

	}
</script>

<style scoped lang="less">
	#haoke1 {
		margin: 0;
		padding: 0;
		font-size: 14px;

		.block_page {
			padding: 0 5px;
		}

		.tableheadBox {
			display: flex;
			margin-bottom: 10px;
			/*justify-content: space-between;*/
			align-items: center;
			float: right;
			padding: 5px;
		}

		header {
			display: flex;
			justify-content: space-between;
			align-items: center;
			padding: 5px 5px 0;

			.countList {
				margin: 10px 0;
				display: flex;
				justify-content: center;
				align-items: center;

				ul {
					margin: 0;
					list-style: none;
					display: flex;

					li {
						margin-right: 0.1rem;

						.money {
							color: #ff0204;
							padding: 0 5px;
						}

						.part {
							color: #46c1ac;
							padding: 0 5px;
						}

						.person {
							color: #00a6fc;
							padding: 0 5px;
						}

					}
				}
			}


		}

		.btn,
		.btn:hover {
			background-color: #7d71c7 !important;
			color: white !important;
			border: 0;
			padding: 3px 15px;
			font-size: 12px;
		}

		.btns{
			margin-right: 5px;
		}
		.btns,
		.btns:hover {
			background-color: #7d71c7 !important;
			color: white !important;
			border: 0;
		}

		.msg {
			width: 120px;
		}

		.shangsj {
			width: 200px;
		}

	}
</style>




// WEBPACK FOOTER //
// src/pages/haoke/xzjl.vue